module.exports = "\n<!-- <div class=\"pageStyle\">\n  <h1>4O4</h1>\n  <h2>Page Not Found</h2>\n</div> -->\n\n"